import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {delay} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  isLoading$: Observable<boolean>;
  isTransparent: boolean = true;

  private subject = new BehaviorSubject<boolean>(false);
  private map = new Map<string, boolean>();

  constructor() {
    this.isLoading$ = this.subject.asObservable().pipe(delay(0));
  }

  set(value: boolean, url: string): void {
    if (value) {
      this.map.set(url, value);
      this.subject.next(true);
      this.setTransparent();
      return;
    }

    if (!value && this.map.has(url)) {
      this.map.delete(url);

      if (url === 'platform') {
        this.isTransparent = true;
      }
    }

    if (this.map.size === 0) {
      this.subject.next(false);
    }

    this.setTransparent();
  }

  setTransparent(): void {
    this.isTransparent = !(this.map.has('platform') || this.map.has('token'));
  }
}
